import * as I from "immutable";
import Raven from "raven-js";
import React, {Component} from "react";
import PropTypes from "prop-types";

import {trackEvent} from "metrics";
import {getRouteLabel} from "utils";

import api from "v2/api";
import {AppData, Route} from "v2/api/Records";
import ModalForm from "v2/components/responsive/ModalForm";

export default class DeleteRouteForm extends Component {
  static contextTypes = {
    appData: PropTypes.instanceOf(AppData),
    location: PropTypes.object,
    onUpdateDateData: PropTypes.func,
    params: PropTypes.shape({
      date: PropTypes.string.isRequired,
      routeId: PropTypes.string.isRequired,
    }),
    routeData: PropTypes.instanceOf(Route),
    router: PropTypes.object,
  }
  static propTypes = {
    modal: PropTypes.bool,
    onCancel: PropTypes.func,
  }

  state = {
    submitted: false,
  }

  handleSubmit = (evt) => {
    evt.preventDefault();
    this.setState({
      submitted: true,
    });

    const {
      location: {query},
      onUpdateDateData,
      params: {date, routeId},
      routeData,
      router,
    } = this.context;
    const {modal, onCancel} = this.props;

    api()
      .delete(this.apiUrl, {
        validateStatus: (status) => status === 204,
      })
      .then(() => {
        onUpdateDateData(null, () => {
          if (modal) {
            onCancel();
          }
          trackEvent("Delete Route", ["Route", "delete", routeId], {
            Date: date,
            "Has Scheduler Route?": Boolean(routeData.schedulerRouteId),
            ID: routeId,
            Type: routeData.type,
          });
          router.push({
            pathname: `/${date}`,
            query,
          });
        });
      })
      .catch((err) => {
        if (err.response) {
          this.setState({
            errors: I.Map(err.response.data),
            submitted: false,
          });
        } else {
          Raven.captureException(err);
        }
      });
  }

  get apiUrl() {
    const {params: {routeId}} = this.context;
    return `/routes/${routeId}`;
  }

  renderContent() {
    const {appData: {serviceType}, routeData} = this.context;
    return [
      <p className="text-danger" key="danger">
        <strong>
          This operation cannot be undone.
        </strong>
      </p>,
      <p key="normal">
        <strong>{getRouteLabel(routeData)}</strong>
        {" "}{serviceType.get(routeData.type)} Route and all its Destinations
        and Tasks will be entirely removed from the system.
      </p>,
    ];
  }

  render() {
    const {submitted} = this.state;
    return (
      <ModalForm
        btnSubmitClassName="btn-danger"
        btnSubmitDisabled={submitted}
        btnSubmitLabel="Delete"
        modalTitle="Are You Sure?"
        onSubmit={this.handleSubmit}
        pageTitle="Delete Route"
        {...this.props}>
        {this.renderContent()}
      </ModalForm>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/responsive/DeleteRouteForm.js
 **/